import React, { useState } from "react"
import Modal from "react-modal";
import * as styles from "../Header/HeaderSp.module.scss"
import styled from 'styled-components'
import { ContactInfo } from "../index"
import { RecruitNav } from "./index";
import { StaticImage } from "gatsby-plugin-image"//ローカルから画像を持ってくる

// react-modalの初期設定
// root nodeのSelectorを設定
Modal.setAppElement("#___gatsby");

const modalStyle = {
  overlay: {
    zIndex: 15,
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    width: "100vw",
    height: "100vh"
  },
  content: {
    width: "100vw",
    height: "100vh",
    inset: 0,
    padding: 0,
    overflowX: "hidden",
    overflowY: "scroll",
    border: "none",
    backgroundColor: "#FFF"
  }
}

const RecruitHeaderSp = ({ pageName, ...props }) => {

  // モーダルの表示状態と切り替える為にState(props)を準備
  const [modalIsOpen, setIsOpen] = useState(false);
  // const handleNavClick=()=>{
  //   this.setIsOpen(false);
  // };
  function closeModal() {
    setIsOpen(false);
  }

  return (
    <>
      <Button isOpen={modalIsOpen} onClick={() => setIsOpen(!modalIsOpen)}>
        <LineWrap>
          <Line isOpen={modalIsOpen}></Line>
          <Line isOpen={modalIsOpen}></Line>
          <Line isOpen={modalIsOpen}></Line>
        </LineWrap>
        <strong>{modalIsOpen ? "close" : "menu"}</strong>
      </Button>
      <Modal
        style={modalStyle}
        isOpen={(modalIsOpen === true)}
        onRequestClose={() => setIsOpen()}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
      >
        <div className={styles.logo}>
          <StaticImage
            width={220}
            src="../../images/recruit/logo-after@2x.png"
            alt="logo"
            placeholder="tracedSVG"
          />
        </div>
        <RecruitNav pageName={pageName} closeModal={closeModal} />
        <div className={styles.MenuBtm}>
          <ContactInfo className={styles.ContactInfo} />
        </div>
      </Modal>
    </>
  )
}
export default RecruitHeaderSp

const Button = styled.button`
  display: block;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 75px;
  border-radius: 0 0 0 25px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 25;
  >strong{
    font-size: 12px;
    font-family: "Rubik";
    color: #EEB718;
    margin-top: 7px;
  }
  ${({ isOpen }) => `
    background-color: ${isOpen ? "#EEB718" : "#fff"};
    >strong{
      color: ${isOpen ? "#fff" : "#EEB718"};
    }
  `}
`
const LineWrap = styled.span`
  position: relative;
  display: block;
  width: 24px;
  height: 21px;
`

const Line = styled.span`
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 3px;
  position: absolute !important;
  left: 0;
  transform-origin: center;
  :first-child{
    top: 0px;
  }
  :nth-child(2){
    top: 9px;
  }
  :nth-child(3){
    bottom: 0;
  }
  position: relative;
  transition: transform 300ms;
  ${({ isOpen }) => `
    background-color: ${isOpen ? "#fff" : "#EEB718"};
    :first-child{
      transform: translate(${isOpen ? "0px,9px" : "0px"}) rotate(${isOpen ? "-45deg" : " 0deg"});
    }
    :nth-child(2){
      opacity:${isOpen ? "0" : "1"};
    }
    :nth-child(3){
      transform: translate(${isOpen ? "0px,-9px" : "0px"}) rotate(${isOpen ? "45deg" : " 0deg"}) ;
    }
  `}

`